import React, { useCallback } from 'react';
import merge from 'classnames';

import { Props, SHINGLE_COLORS } from './types';

import styles from './ShingleColorTile.module.scss';

export const ShingleColorTile = ({ classes, shingleColor, isActive, selectColor }: Props) => {
  const isPlus = shingleColor.asphaltShingleColor?.includes('Plus');
  const colorName = shingleColor.asphaltShingleColor?.replace('Plus', '');
  const imageUrl = SHINGLE_COLORS[shingleColor.asphaltShingleColor as string];

  const handleTileClick = useCallback(() => {
    selectColor(shingleColor);
  }, [selectColor, shingleColor]);

  return (
    <div className={merge(styles.shingleColorTileWrapper, classes?.wrapper)}>
      <button
        className={merge(
          styles.shingleColorTile,
          {
            [styles.activeShingleColorTile]: isActive,
          },
          classes?.container,
        )}
        data-testid={shingleColor.asphaltShingleColor}
        onClick={handleTileClick}
        type="button"
      >
        <div className={merge(styles.shingleColorTileImageWrapper, classes?.imageWrapper)}>
          <img
            alt={colorName}
            className={merge(styles.shingleColorTileImage, classes?.image)}
            src={imageUrl}
          />
          {isPlus && (
            <div className={merge(styles.shingleColorPlusLabel, classes?.imageLabel)}>
              <p>Plus</p>
            </div>
          )}
        </div>
        <p className={merge(styles.shingleColorTileTitle, classes?.title)}>
          {colorName}
          {isPlus && <span>PLUS</span>}
        </p>
      </button>
    </div>
  );
};
